export const REFERRAL_QUERY_PARAM = 'ref'

export function normalizeReferralCode(code: string | null | undefined): string | undefined {
  const normalized = code?.trim().toUpperCase()
  if (!normalized) return undefined
  return normalized
}

export function parseReferralCode(url: string | URL): string | undefined {
  const searchParams = (typeof url === 'string' ? new URL(url) : url).searchParams
  return normalizeReferralCode(searchParams.get(REFERRAL_QUERY_PARAM))
}
